export default "__VITE_ASSET__VgGWNZEZ__"